import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState } from 'react';
import styled from 'styled-components';
import { COLORS, SIZES } from '../styleVars';
import { Typography } from '../typography/Typography';
var Container = styled.div.withConfig({
  componentId: "sc-z98e9g-0"
})(["position:relative;z-index:70;"]);
var Row = styled.div.withConfig({
  componentId: "sc-z98e9g-1"
})(["display:flex;align-items:center;height:", ";padding:0 ", ";input{-webkit-tap-highlight-color:transparent;position:absolute;width:", ";height:", ";margin:0;padding:0;opacity:0;cursor:pointer;}"], SIZES['24'], SIZES['16'], SIZES['24'], SIZES['24']);
var CheckboxIcon = styled.div.withConfig({
  componentId: "sc-z98e9g-2"
})(["margin-right:", ";height:", ";width:", ";"], SIZES['8'], SIZES['24'], SIZES['24']);
var Svg = styled.svg.withConfig({
  componentId: "sc-z98e9g-3"
})(["fill:currentColor;width:1em;height:1em;display:inline-block;font-size:", ";flex-shrink:0;"], SIZES[24]);

var Checkbox = function Checkbox(_ref) {
  var _ref$initiallyChecked = _ref.initiallyChecked,
      initiallyChecked = _ref$initiallyChecked === void 0 ? false : _ref$initiallyChecked,
      _ref$label = _ref.label,
      label = _ref$label === void 0 ? '' : _ref$label,
      onToggle = _ref.onToggle,
      _ref$tabIndex = _ref.tabIndex,
      tabIndex = _ref$tabIndex === void 0 ? 0 : _ref$tabIndex,
      className = _ref.className;

  var _useState = useState(initiallyChecked),
      _useState2 = _slicedToArray(_useState, 2),
      checked = _useState2[0],
      setChecked = _useState2[1];

  var handleClick = function handleClick() {
    setChecked(!checked);
    onToggle(!checked);
  };

  var displayedIcon = checked ? /*#__PURE__*/React.createElement(Svg, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    style: {
      color: COLORS.fupaSecondary
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
  })) : /*#__PURE__*/React.createElement(Svg, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    style: {
      color: COLORS.grey
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
  }));
  return /*#__PURE__*/React.createElement(Container, {
    className: className
  }, /*#__PURE__*/React.createElement(Row, {
    onClick: handleClick
  }, /*#__PURE__*/React.createElement("input", {
    tabIndex: tabIndex,
    type: "checkbox"
  }), /*#__PURE__*/React.createElement(CheckboxIcon, null, displayedIcon), /*#__PURE__*/React.createElement(Typography, {
    variant: "body1",
    component: "label"
  }, label)));
};

export { Checkbox };
//# sourceMappingURL=Checkbox.js.map